import { useSelector } from 'react-redux';

import { isDevelopment } from '@core/blocks/edu-match/utils/determineEnv';
import { type Flags } from '@core/context/FeatureFlagsContext';
import { MonarchEditableAsset } from '@core/context/types';
import { qualifyEduRequest } from '@core/services/leadDelivery';

import { type InjectionKey } from './getQuestionInjectionSchema';
import { type GCPParams, generateQualifyPayload, getQualifiedPartnerKeys } from './utils/qualifications';

type GNCPSParams = {
  flags: Flags;
  userChoseAsap?: boolean;
} & GCPParams;

export const isEditableAsset = (asset?: unknown) =>
  asset &&
  (asset as MonarchEditableAsset)?.questionStepId &&
  (asset as MonarchEditableAsset)?.questionStepName &&
  asset !== 'conditions_not_met';

const getInjectionKeys = async ({
  userChoseAsap,
  dcs,
  ipInferredPostalCode,
  flags,
  publisher,
}: GNCPSParams): Promise<InjectionKey[]> => {
  // If noPii flag is true, skip EAB, EMCC, and securityBoost injections
  if (flags.noPii && userChoseAsap) {
    return ['noPiiTest'];
  }

  const qualifyPayload = generateQualifyPayload({ dcs, ipInferredPostalCode, publisher });

  const res = await qualifyEduRequest(qualifyPayload);

  if (res instanceof Error) {
    return [];
  }

  let injectionKeys = getQualifiedPartnerKeys(res.qualified, flags);

  Object.entries(flags).forEach(([key, value]) => {
    if (isEditableAsset(value)) injectionKeys.push(key as keyof Flags);
  });

  // Hardcoded rules
  if (injectionKeys.includes('EMCC')) {
    // Remove EAB keys if EMCC is present
    injectionKeys = injectionKeys.filter((key) => !key.includes('EAB'));
  }

  if (isDevelopment()) {
    console.log('Flags:', flags);
    console.log('Injection Keys:', injectionKeys);
  }
  return injectionKeys;
};

export default getInjectionKeys;
